export default __webpack_public_path__ + "static/8-0e5704946808d285d48b1d63d29bed1b.png";